var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import store from '../store';
import routes from '../routes';
import GuardedRoute from '../security/GuardedRoute';
import VirtualAnalyticsWrapper from './VirtualAnalyticsWrapper';
import { CONFIG } from '../../common/config';
import { getUserToken } from '../core/helpers/axios';
import { getLayoutComponent } from '../layouts';
import { addLocalePrefixToRoutePath } from '../core/helpers/url-helper';
import { fetchUser } from '../modules/Auth/store/actions';
import { fetchCartItems, fetchDraftItems } from '../modules/Cart/store/actions';
import { fetchProducts } from '../modules/Products/store/actions';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.windowInnerHeight = 0;
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    App.prototype.componentDidMount = function () {
        if (getUserToken()) {
            fetchUser()(store.dispatch);
        }
        fetchCartItems()(store.dispatch);
        fetchDraftItems()(store.dispatch);
        fetchProducts()(store.dispatch);
        this.updateVhProperty();
        window.addEventListener('resize', this.handleWindowResize);
    };
    App.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    App.prototype.render = function () {
        var _this = this;
        return (React.createElement(VirtualAnalyticsWrapper, null,
            React.createElement(Switch, null,
                routes.map(function (route, key) {
                    route.path = addLocalePrefixToRoutePath(_this.props.t(route.path));
                    return route.guarded
                        ? React.createElement(GuardedRoute, __assign({ key: key }, route))
                        : _this.renderRoute(key, route);
                }),
                React.createElement(Redirect, { to: "/" + CONFIG.LOCALES.DEFAULT }))));
    };
    App.prototype.renderRoute = function (key, route) {
        var _a;
        var C = route.component;
        var LayoutComponent = getLayoutComponent(route.layout);
        return (React.createElement(Route, { key: key, path: route.path },
            React.createElement(LayoutComponent, __assign({}, ((_a = route.layoutParams) !== null && _a !== void 0 ? _a : {})),
                React.createElement(C, null))));
    };
    App.prototype.handleWindowResize = function () {
        this.updateVhProperty();
    };
    App.prototype.updateVhProperty = function () {
        if (window.innerHeight === this.windowInnerHeight) {
            return;
        }
        this.windowInnerHeight = window.innerHeight;
        var vh = this.windowInnerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + "px");
    };
    return App;
}(React.Component));
export default withTranslation()(App);
